(() => {
  const strings = window.accessibilityStrings || {};

  const announce = (message, region) => {
    const target = region || document.getElementById('AccessibilityLiveRegion');
    if (!target || !message) return;
    target.textContent = '';
    setTimeout(() => { target.textContent = message; }, 100);
  };
  window.accessibilityAnnounce = announce;

  const cartRegion = () => {
    const drawerRegion = document.getElementById('CartDrawer-LiveRegionText');
    const cartOpen = window.Alpine && Alpine.store('xMiniCart') && Alpine.store('xMiniCart').open;
    return cartOpen && drawerRegion ? drawerRegion : null;
  };

  const makeClickableAccessible = (el, label) => {
    if (el.matches('a, button, input, select, textarea') || el.dataset.keyboardAccessible) return;
    el.dataset.keyboardAccessible = 'true';
    el.setAttribute('role', 'button');
    el.setAttribute('tabindex', '0');
    if (label && !el.textContent.trim()) el.setAttribute('aria-label', label);
    el.addEventListener('keydown', (event) => {
      if (event.target !== el || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      el.click();
    });
  };

  window.accessibilityEnhanceMenu = (root) => {
    if (!root) return;
    root.querySelectorAll('[\\@click*="setActiveLink"]').forEach((el) => makeClickableAccessible(el));
    root.querySelectorAll('[\\@click*="removeActiveLink"]').forEach((el) => makeClickableAccessible(el, strings.back || 'Back'));
  };

  const updateCartLabels = () => {
    const bubble = document.querySelector('#cart-icon-bubble .count_item');
    const count = bubble && !bubble.classList.contains('hidden') ? parseInt(bubble.textContent, 10) || 0 : 0;
    const template = count === 1 ? strings.cartCountOne : strings.cartCountOther;
    if (!template) return;
    document.querySelectorAll('[data-cart-count-label]').forEach((link) => {
      link.setAttribute('aria-label', template.replace('[count]', count));
    });
  };
  document.addEventListener('eurus:cart:items-changed', () => setTimeout(updateCartLabels, 0));

  const describeNewTabLink = (link) => {
    if (!link.matches('a[target="_blank"]') || link.hasAttribute('aria-describedby')) return;
    if (document.getElementById('a11y-new-window-message')) link.setAttribute('aria-describedby', 'a11y-new-window-message');
  };
  const hideDecorativeIcons = () => {
    document.querySelectorAll('svg:not([aria-hidden]):not([role]):not([aria-label]):not([aria-labelledby])').forEach((svg) => {
      if (svg.querySelector('title')) return;
      svg.setAttribute('aria-hidden', 'true');
      svg.setAttribute('focusable', 'false');
    });
  };
  const nameCarousels = () => {
    document.querySelectorAll('.splide[aria-roledescription="carousel"]:not([aria-label]):not([aria-labelledby])').forEach((carousel) => {
      const section = carousel.closest('.shopify-section') || carousel.parentElement;
      const heading = section && section.querySelector('h1, h2, h3, .h2, .h3, .h4');
      const label = heading && heading.textContent.trim().replace(/\s+/g, ' ');
      if (label) carousel.setAttribute('aria-label', label);
    });
  };
  const enhanceDynamicContent = () => {
    document.querySelectorAll('a[target="_blank"]').forEach(describeNewTabLink);
    hideDecorativeIcons();
    nameCarousels();
  };
  enhanceDynamicContent();
  let enhanceTimer;
  new MutationObserver(() => {
    clearTimeout(enhanceTimer);
    enhanceTimer = setTimeout(enhanceDynamicContent, 300);
  }).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('focusin', (event) => {
    if (event.target.closest) {
      const link = event.target.closest('a[target="_blank"]');
      if (link) describeNewTabLink(link);
    }
  });

  const makeScrollBoxesFocusable = () => {
    document.querySelectorAll('.x-testimonial-main-content').forEach((box) => {
      const scrollable = box.scrollHeight > box.clientHeight + 2;
      if (scrollable && !box.hasAttribute('tabindex')) {
        box.setAttribute('tabindex', '0');
        box.setAttribute('role', 'region');
        const title = box.querySelector('h3, .x-content-title');
        if (title) box.setAttribute('aria-label', title.textContent.trim());
      } else if (!scrollable && box.getAttribute('tabindex') === '0') {
        box.removeAttribute('tabindex');
        box.removeAttribute('role');
        box.removeAttribute('aria-label');
      }
    });
  };
  window.addEventListener('load', makeScrollBoxesFocusable);
  window.addEventListener('resize', () => {
    clearTimeout(window.__scrollBoxTimer);
    window.__scrollBoxTimer = setTimeout(makeScrollBoxesFocusable, 300);
  });

  document.addEventListener('eurus:product:added', (event) => {
    if (event.detail && event.detail.announced) return;
    const product = event.detail && event.detail.product;
    const title = product && (product.product_title || product.title) || '';
    const message = (strings.itemAdded || '[product] added to cart').replace('[product]', title).trim();
    let attempts = 0;
    const announceWhenCartOpens = () => {
      const region = cartRegion();
      if (region || attempts >= 20) {
        setTimeout(() => announce(message, region), region ? 400 : 0);
        return;
      }
      attempts += 1;
      setTimeout(announceWhenCartOpens, 150);
    };
    announceWhenCartOpens();
  });
  const focusableSelector = 'button:not([disabled]), [href], input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const firstVisibleFocusable = (root) => Array.from(root.querySelectorAll(focusableSelector))
    .find((el) => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.closest('[aria-hidden="true"]'));

  window.accessibilityChooseOptions = (panel, open) => {
    if (open) {
      const opener = document.activeElement;
      if (!opener || opener === document.body) return;
      panel.accessibilityOpener = opener;
      let attempts = 0;
      const focusFirst = () => {
        const content = panel.querySelector('.choose-options');
        const target = content && firstVisibleFocusable(content);
        if (target) {
          target.focus();
        } else if (attempts < 20) {
          attempts += 1;
          setTimeout(focusFirst, 150);
        }
      };
      setTimeout(focusFirst, 350);
    } else {
      const opener = panel.accessibilityOpener;
      panel.accessibilityOpener = null;
      if (opener && opener.isConnected && (panel.contains(document.activeElement) || document.activeElement === document.body)) {
        opener.focus();
      }
    }
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('a.skip-to-content[href^="#"]');
    if (!link) return;
    const id = link.getAttribute('href').slice(1);
    const scope = link.closest('[role="dialog"]') || document;
    const target = scope.querySelector('[id="' + CSS.escape(id) + '"]');
    if (!target) return;
    event.preventDefault();
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    target.focus();
  }, true);
  window.accessibilityAnnounceHtml = (html) => {
    if (!html) return;
    const div = document.createElement('div');
    div.innerHTML = html;
    const text = div.textContent.replace(/\s+/g, ' ').trim();
    if (text) announce(text);
  };

  window.accessibilitySubPanel = (panel, open) => {
    const focusStore = window.Alpine && Alpine.store('xFocusElement');
    if (!focusStore) return;
    if (open) {
      if (panel.accessibilityOpen) return;
      panel.accessibilityOpen = true;
      const active = document.activeElement;
      panel.accessibilityOpener = active && active !== document.body ? active : null;
      let attempts = 0;
      const focusField = () => {
        const field = panel.querySelector('input:not([type="hidden"]), select, textarea');
        const ready = field && field.getClientRects().length && field.getBoundingClientRect().top < window.innerHeight;
        if (!ready && attempts < 6) {
          attempts += 1;
          setTimeout(focusField, 100);
          return;
        }
        focusStore.trapFocus(panel, ready ? field : null);
      };
      setTimeout(focusField, 150);
    } else if (panel.accessibilityOpen) {
      panel.accessibilityOpen = false;
      const opener = panel.accessibilityOpener && panel.accessibilityOpener.isConnected ? panel.accessibilityOpener : null;
      panel.accessibilityOpener = null;
      const parentDialog = panel.parentElement && panel.parentElement.closest('[role="dialog"]');
      if (parentDialog) {
        focusStore.trapFocus(parentDialog, opener);
      } else {
        focusStore.removeTrapFocus(opener);
      }
    }
  };
  document.addEventListener('alpine:initialized', () => {
    const coupon = window.Alpine && Alpine.store('xCouponCodeDetail');
    if (!coupon || !Alpine.effect) return;
    const announceVisible = (selector) => {
      setTimeout(() => {
        const el = Array.from(document.querySelectorAll(selector)).find((node) => node.getClientRects().length && node.textContent.trim());
        if (el) announce(el.textContent.replace(/\s+/g, ' ').trim());
      }, 200);
    };
    ['discountFaild', 'discountCorrect', 'discountApplied', 'freeShippingApplied'].forEach((flag) => {
      Alpine.effect(() => {
        if (coupon[flag]) announceVisible(`[x-show*="${flag}"]`);
      });
    });
    Alpine.effect(() => {
      if (coupon.removedDiscountCode) announceVisible('.text-removed-discount');
    });
  });
  const KEYBOARD_ARROWS_CLASS = 'accessibility-keyboard-arrows';
  const ARROW_SELECTOR = '.splide__arrow, .splide__arrows button, .accessibility-carousel-arrows button';
  // Drag-only carousels (progress bar, no arrow markup) get their own arrows for keyboard users
  const addCarouselArrows = (carousel) => {
    const track = carousel.querySelector('.splide__track');
    if (!track || carousel.querySelector('.accessibility-carousel-arrows')) return;
    const strings = window.accessibilityStrings || {};
    const wrapper = document.createElement('div');
    wrapper.className = 'accessibility-carousel-arrows';
    [['<', strings.previousSlide || 'Previous slide'], ['>', strings.nextSlide || 'Next slide']].forEach(([control, label]) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', label);
      button.addEventListener('click', () => carousel.splide && carousel.splide.go(control));
      wrapper.appendChild(button);
    });
    track.before(wrapper);
  };
  const KEYBOARD_ARROWS_OBSERVE = { attributes: true, attributeFilter: ['class'], subtree: true };
  let keyboardArrowsObserver;
  const updateKeyboardArrows = () => {
    // Pause the observer so this function's own class changes don't re-trigger it
    keyboardArrowsObserver.disconnect();
    try {
      document.querySelectorAll('.splide').forEach((carousel) => {
        const sliding = carousel.classList.contains('is-initialized') && carousel.classList.contains('is-overflow') && !carousel.closest('[id$="__announcement-bar"]');
        if (sliding && carousel.splide && carousel.querySelector('.splide-progress') && !carousel.querySelector('.splide__arrow, .splide__arrows button')) addCarouselArrows(carousel);
        const arrows = carousel.querySelectorAll(ARROW_SELECTOR);
        if (!sliding || !arrows.length) {
          carousel.classList.remove(KEYBOARD_ARROWS_CLASS);
          return;
        }
        if (carousel.contains(document.activeElement) && carousel.classList.contains(KEYBOARD_ARROWS_CLASS)) return;
        carousel.classList.remove(KEYBOARD_ARROWS_CLASS);
        const hidden = Array.from(arrows).some((arrow) => !arrow.getClientRects().length);
        if (hidden) carousel.classList.add(KEYBOARD_ARROWS_CLASS);
      });
    } finally {
      keyboardArrowsObserver.observe(document.body, KEYBOARD_ARROWS_OBSERVE);
    }
  };
  let keyboardArrowsTimer;
  const scheduleKeyboardArrows = () => {
    clearTimeout(keyboardArrowsTimer);
    keyboardArrowsTimer = setTimeout(updateKeyboardArrows, 200);
  };
  keyboardArrowsObserver = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.target.classList && mutation.target.classList.contains('splide'))) scheduleKeyboardArrows();
  });
  keyboardArrowsObserver.observe(document.body, KEYBOARD_ARROWS_OBSERVE);
  window.addEventListener('resize', scheduleKeyboardArrows);
  window.addEventListener('load', scheduleKeyboardArrows);
})();
